module.exports = __webpack_public_path__ + "static/img/WisdomSiteXianchang.321dd55.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/WisdomSite/WisdomSiteXianchang.png
// module id = 2pmR
// module chunks = 12